import { render, staticRenderFns } from "./BankCredsHelpPopup.vue?vue&type=template&id=bf65fe3c&scoped=true"
import script from "./BankCredsHelpPopup.vue?vue&type=script&lang=js"
export * from "./BankCredsHelpPopup.vue?vue&type=script&lang=js"
import style0 from "./BankCredsHelpPopup.vue?vue&type=style&index=0&id=bf65fe3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf65fe3c",
  null
  
)

export default component.exports